export const color = Object.freeze({
    // colors for light backgrounds
    'default': {
        background: {
            disabled: '',
            accent: {
                blue: {
                    bolder: '#2684ff',
                    subtle: '#4c9aff',
                    subtler: '#B3D4FF',
                    subtlest: '#deebff'
                },
                gray: {
                    bolder: '#97a0af',
                    subtle: '#b3bac5',
                    subtler: '#c1c7d0',
                    subtlest: '#f4f5f7'
                },
                green: {
                    bolder: '#57D9A3',
                    subtle: '#79f2c0',
                    subtler: '#abf5d1',
                    subtlest: '#e3fcef'
                },
                magenta: {
                    bolder: '',
                    subtle: '',
                    subtler: '',
                    subtlest: ''
                },
                orange: {
                    bolder: '',
                    subtle: '',
                    subtler: '',
                    subtlest: ''
                },
                purple: {
                    bolder: '#8777d9',
                    subtle: '#998dd9',
                    subtler: '#c0b6f2',
                    subtlest: '#eae6ff'
                },
                red: {
                    bolder: '#ff7452',
                    subtle: '#ff8f73',
                    subtler: '#ffbdad',
                    subtlest: '#FFEBE6'
                },
                teal: {
                    bolder: '#00C7E6',
                    subtle: '#79e2f2',
                    subtler: '#b3f5ff',
                    subtlest: '#e6fcff'
                },
                yellow: {
                    bolder: '',
                    subtle: '',
                    subtler: '',
                    subtlest: ''
                }
            },
            brand: {
                default: '#deebff',
                hovered: '#B3D4FF',
                pressed: '#deebff',
                bold: {
                    default: '#0052cc',
                    hovered: '#0747A6',
                    pressed: '#091e42'
                }
            },
            danger: {
                default: '#FFEBE6',
                hovered: '#ffbdad',
                pressed: '#ff8f73',
                bold: {
                    default: '#de350b',
                    hovered: '#bf2600',
                    pressed: '#751902'
                }
            },
            discovery: {
                default: '#c0b6f2',
                hovered: '#998dd9',
                pressed: '#8777d9',
                bold: {
                    default: '#6554c0',
                    hovered: '#5243aa',
                    pressed: '#403294'
                }
            },
            information: {
                default: '#deebff',
                bold: {
                    default: '#0052cc',
                    hovered: '#0747A6',
                    pressed: '#091e42'
                }
            },
            input: {
                default: '#ebecf0',
                hovered: '#a5adba',
                pressed: '#c1c7d0'
            },
            selected: {
                default: '#B3D4FF',
                hovered: '#4c9aff',
                pressed: '#2684ff',
                bold: {
                    default: '#6B778C',
                    hovered: '#42526e',
                    pressed: '#091e42'
                }
            },
            success: {
                default: '#abf5d1',
                hovered: '#79f2c0',
                pressed: '#57D9A3',
                bold: {
                    default: '#00875a',
                    hovered: '#006644',
                    pressed: '#003D28'
                }
            },
            warning: {
                default: '#FFF0B3',
                hovered: '#ffe380',
                pressed: '#ffc400',
                bold: {
                    default: '#ffab00',
                    hovered: '#ff991f',
                    pressed: '#ff8b00'
                }
            }
        },
        blanket: {
            default: '#505f79'
        },
        border: {
            bold: '#42526e',
            brand: '#0052cc',
            danger: '#de350b',
            default: '#a5adba',
            disabled: '#c1c7d0',
            discovery: '#5243aa',
            focus: '#2684ff',
            information: '#0065ff',
            inverse: '#ffffff',
            selected: '#0052cc',
            success: '#00875a',
            warning: '#ff991f',
            accent: {
                blue: '#0065ff',
                gray: '#97a0af',
                green: '#36b37e',
                magenta: '',
                orange: '#ff991f',
                purple: '#8777d9',
                red: '#ff5630',
                teal: '#00b8d9',
                yellow: '#ffc400'
            }
        },
        elevation: {
            surface: {
                footer: '#f4f5f7',
                default: {
                    solid: {
                        alternate1: '#c0b6f2',
                        alternate2: '#B3D4FF',
                        alternate3: '#DFE1E6',
                        primary: '#ffffff'
                    }
                },
                overlay: {
                    default: '#ffffff'
                },
                raised: {
                    default: '#ffffff'
                }
            }
        },
        icon: {
            'brand': '#0052cc',
            'danger': '#bf2600',
            'default': '#172b4d',
            'disabled': '#b3bac5',
            'discovery': '#403294',
            'information': '#0747A6',
            'inverse': '#ffffff',
            'selected': '#0747A6',
            'subtle': '#6B778C',
            'subtlest': '#97a0af',
            'success': '#006644',
            'warning-inverse': '#091e42',
            'warning': '#ff8b00',
            'accent': {
                blue: '#0747A6',
                gray: '#7a869a',
                green: '#00875a',
                magenta: '',
                orange: '#ff8b00',
                purple: '#5243aa',
                red: '#de350b',
                teal: '#00a3bf',
                yellow: '#ffc400'
            }
        },
        link: {
            default: '#0052cc',
            pressed: '#0747A6',
            subtle: '#505f79'
        },
        text: {
            'brand': '#0052cc',
            'danger': '#bf2600',
            'default': '#253858',
            'disabled': '#97a0af',
            'discovery': '#403294',
            'information': '#091e42',
            'inverse': '#ffffff',
            'selected': '#0052cc',
            'subtle': '#505f79',
            'subtlest': '#7a869a',
            'success': '#006644',
            'warning-inverse': '#253858',
            'warning': '#ff8b00',
            'accent': {
                'blue-bolder': '#091e42',
                'blue': '#0747A6',
                'gray-bolder': '',
                'gray': '#505f79',
                'green-bolder': '',
                'green': '#006644',
                'magenta-bolder': '',
                'magenta': '',
                'orange-bolder': '',
                'orange': '#ff8b00',
                'purple-bolder': '',
                'purple': '#403294',
                'red-bolder': '',
                'red': '#bf2600',
                'teal-bolder': '',
                'teal': '#008da6',
                'yellow-bolder': '',
                'yellow': '#ffc400'
            }
        },
        utility: {
            MISSING_TOKEN: '#FA11F2'
        }
    },
    'lo-fi': {
        background: {
            'items-light': '#ffffff',
            'items': '#42526e',
            'surface': '#ffffff'
        },
        text: {
            default: '#000000'
        }
    },
    // colors for dark backgrounds
    'inverse': {
        background: {
            disabled: '',
            accent: {
                blue: {
                    bolder: '#2684ff',
                    subtle: '#0747A6',
                    subtler: '#344563',
                    subtlest: '#253858'
                },
                gray: {
                    bolder: '#8993a4',
                    subtle: '#5e6c84',
                    subtler: '#42526e',
                    subtlest: '#253858'
                },
                green: {
                    bolder: '#57D9A3',
                    subtle: '#79f2c0',
                    subtler: '#abf5d1',
                    subtlest: '#e3fcef'
                },
                magenta: {
                    bolder: '',
                    subtle: '',
                    subtler: '',
                    subtlest: ''
                },
                orange: {
                    bolder: '',
                    subtle: '',
                    subtler: '',
                    subtlest: ''
                },
                purple: {
                    bolder: '#403294',
                    subtle: '#998dd9',
                    subtler: '#c0b6f2',
                    subtlest: '#eae6ff'
                },
                red: {
                    bolder: '#ff7452',
                    subtle: '#ff8f73',
                    subtler: '#ffbdad',
                    subtlest: '#FFEBE6'
                },
                teal: {
                    bolder: '#00C7E6',
                    subtle: '#79e2f2',
                    subtler: '#b3f5ff',
                    subtlest: '#e6fcff'
                },
                yellow: {
                    bolder: '',
                    subtle: '',
                    subtler: '',
                    subtlest: ''
                }
            },
            brand: {
                default: '#deebff',
                hovered: '',
                pressed: '',
                bold: {
                    default: '#091e42',
                    hovered: '#0747A6',
                    pressed: '#091e42'
                }
            },
            danger: {
                default: '#FFEBE6',
                hovered: '#ffbdad',
                pressed: '#ff8f73',
                bold: {
                    default: '#de350b',
                    hovered: '#bf2600',
                    pressed: '#751902'
                }
            },
            discovery: {
                default: '#c0b6f2',
                hovered: '#998dd9',
                pressed: '#8777d9',
                bold: {
                    default: '#6554c0',
                    hovered: '#5243aa',
                    pressed: '#403294'
                }
            },
            information: {
                default: '#B3D4FF',
                hovered: '#4c9aff',
                pressed: '#2684ff',
                bold: {
                    default: '#0052cc',
                    hovered: '#0747A6',
                    pressed: '#091e42'
                }
            },
            input: {
                default: '#091e42'
            },
            selected: {
                default: '#ffffff',
                hovered: '#4c9aff',
                pressed: '#2684ff',
                bold: {
                    default: '#0052cc',
                    hovered: '#0747A6',
                    pressed: '#091e42'
                }
            },
            success: {
                default: '#abf5d1',
                hovered: '#79f2c0',
                pressed: '#57D9A3',
                bold: {
                    default: '#00875a',
                    hovered: '#006644',
                    pressed: '#003D28'
                }
            },
            warning: {
                default: '#FFF0B3',
                hovered: '#ffe380',
                pressed: '#ffc400',
                bold: {
                    default: '#ffab00',
                    hovered: '#ff991f',
                    pressed: '#ff8b00'
                }
            }
        },
        blanket: {
            default: '#000000'
        },
        border: {
            bold: '#42526e',
            brand: '#B3D4FF',
            danger: '#de350b',
            default: '#5e6c84',
            disabled: '#c1c7d0',
            discovery: '#5243aa',
            focus: '#2684ff',
            information: '#0065ff',
            inverse: '#ffffff',
            selected: '#0052cc',
            success: '#00875a',
            warning: '#ff991f',
            accent: {
                blue: '#2684ff',
                gray: '#97a0af',
                green: '#57D9A3',
                magenta: '',
                orange: '#ffab00',
                purple: '#998dd9',
                red: '#ff5630',
                teal: '#79e2f2',
                yellow: '#ffe380'
            }
        },
        elevation: {
            surface: {
                default: {
                    solid: {
                        alternate1: '#5243aa',
                        alternate2: '#0747A6',
                        primary: '#172b4d'
                    }
                },
                overlay: {
                    default: '#ffffff'
                },
                raised: {
                    default: '#253858'
                }
            }
        },
        icon: {
            'brand': '#2684ff',
            'danger': '#ff7452',
            'default': '#ffffff',
            'disabled': '#b3bac5',
            'discovery': '#998dd9',
            'information': '#B3D4FF',
            'inverse': '#000000',
            'selected': '#4c9aff',
            'subtle': '#6B778C',
            'success': '#57D9A3',
            'warning-inverse': '#000000',
            'warning': '#ffe380',
            'accent': {
                blue: '#4c9aff',
                gray: '#7a869a',
                green: '#57D9A3',
                magenta: '',
                orange: '#ffe380',
                purple: '#998dd9',
                red: '#ff8f73',
                teal: '#79e2f2',
                yellow: '#FFF0B3'
            }
        },
        link: {
            alternate: '#ffffff',
            default: '#B3D4FF',
            pressed: '#4c9aff'
        },
        text: {
            'brand': '#B3D4FF',
            'danger': '#ff7452',
            'default': '#f4f5f7',
            'disabled': '#DFE1E6',
            'discovery': '#998dd9',
            'information': '#4c9aff',
            'inverse': '#0747A6',
            'selected': '#2684ff',
            'subtle': '#DFE1E6',
            'subtlest': '#b3bac5',
            'success': '#57D9A3',
            'warning-inverse': '#000000',
            'warning': '#ffc400',
            'accent': {
                'blue-bolder': '#deebff',
                'blue': '#2684ff',
                'gray-bolder': '',
                'gray': '#b3bac5',
                'green-bolder': '',
                'green': '#57D9A3',
                'magenta-bolder': '',
                'magenta': '',
                'orange-bolder': '',
                'orange': '#ffe380',
                'purple-bolder': '',
                'purple': '#998dd9',
                'red-bolder': '',
                'red': '#ff8f73',
                'teal-bolder': '',
                'teal': '#79e2f2',
                'yellow-bolder': '',
                'yellow': '#FFF0B3'
            }
        },
        utility: {
            MISSING_TOKEN: '#FA11F2'
        }
    }
});
//# sourceMappingURL=color.js.map